import tinyColor from "tinycolor2";
import config from "../../config";

const primary = tinyColor("#1cacdd");

const AS_colors = {
  primary: "#1cacdd",
  primary75: primary.setAlpha(0.75).toRgbString(),
  primary50: primary.setAlpha(0.5).toRgbString(),
  primary25: primary.setAlpha(0.25).toRgbString(),
};
const darkColors = {
  neutral0: "hsl(0, 0%, 20%)",
  neutral5: "hsl(0, 0%, 25%)",
  neutral10: "hsl(0, 0%, 30%)",
  neutral20: "hsl(0, 0%, 35%)",
  neutral30: "hsl(0, 0%, 40%)",
  neutral40: "hsl(0, 0%, 45%)",
  neutral50: "hsl(0, 0%, 50%)",
  neutral60: "hsl(0, 0%, 60%)",
  neutral70: "hsl(0, 0%, 70%)",
  neutral80: "hsl(0, 0%, 80%)",
  neutral90: "hsl(0, 0%, 90%)",
};

export default function getTheme({ darkMode }) {
  return function (theme) {
    let colors = { ...theme.colors, ...AS_colors };
    if (config.FF_DARK_MODE && darkMode) {
      colors = { ...colors, ...darkColors };
    }
    return { ...theme, colors };
  };
}
